var UitkLayoutPositionPointerEventsMap = [['none', 'pointerevents-none']];
var UitkLayoutPositionPointerEvents = new Map(UitkLayoutPositionPointerEventsMap);
var UitkLayoutPositionTypeMap = [
    ['relative', 'relative'],
    ['sticky', 'sticky'],
    ['absolute', 'absolute'],
    ['fixed', 'fixed']
];
var UitkLayoutPositionTypes = new Map(UitkLayoutPositionTypeMap);
var UitkLayoutPositionItemZIndexLayerMap = [
    ['layer1', 'layer1'],
    ['layer2', 'layer2'],
    ['layer3', 'layer3'],
    ['layer4', 'layer4'],
    ['layer5', 'layer5'],
    ['layer6', 'layer6'],
    ['layer7', 'layer7']
];
var UitkLayoutPositionItemZIndexLayers = new Map(UitkLayoutPositionItemZIndexLayerMap);
var UitkLayoutPositionValueMap = [
    ['zero', 'zero'],
    ['half', 'half'],
    ['one', 'one'],
    ['two', 'two'],
    ['three', 'three'],
    ['four', 'four'],
    ['six', 'six'],
    ['twelve', 'twelve'],
    ['minus-half', 'minus-half'],
    ['minus-one', 'minus-one'],
    ['minus-two', 'minus-two'],
    ['minus-three', 'minus-three'],
    ['minus-four', 'minus-four'],
    ['minus-six', 'minus-six'],
    ['minus-twelve', 'minus-twelve'],
    ['center', 'center']
];
var UitkLayoutPositionValues = new Map(UitkLayoutPositionValueMap);

export { UitkLayoutPositionItemZIndexLayers, UitkLayoutPositionPointerEvents, UitkLayoutPositionTypes, UitkLayoutPositionValues };
